module.exports = __webpack_public_path__ + "plugins/web/img/小智透视.339b413c.png";